var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackbar"},[_c('div',{staticClass:"snackbar__message",domProps:{"innerHTML":_vm._s(_vm.message)}}),_vm._v(" "),_c('button',{staticClass:"snackbar__close btn-icon",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('IconSvg',{attrs:{"filepath":"close.svg"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }